import { colors } from '../../assets';

export const getComplementaryColorByString = (string: string): string | undefined => {
  // Not every complementary colour has a shade02 (purple only has shade01), so names that map to it get undefined.
  const palette: Record<string, { shade01?: string; shade02?: string }> = colors.complementary;
  const colorsName = Object.keys(palette);

  if (string) {
    return palette[colorsName[Math.abs(string[0].toLowerCase().charCodeAt(0) - 97) % colorsName.length]].shade02;
  } else {
    return palette[colorsName[0]].shade02;
  }
};
